import { AchFeeTemplateFields } from "globalConstants";
import { FeeTemplatesStatusTypes } from "types";

const ZERO = "0.000000";

export const achFeeTemplateInitialValues = {
	[AchFeeTemplateFields.Status.name]: FeeTemplatesStatusTypes.Available,
	[AchFeeTemplateFields.TemplateName.name]: "",
	[AchFeeTemplateFields.SetupFee.name]: ZERO,
	[AchFeeTemplateFields.MonthlyFee.name]: ZERO,
	[AchFeeTemplateFields.TransactionFee.name]: ZERO,
	[AchFeeTemplateFields.OriginationDiscountFee.name]: ZERO,
	[AchFeeTemplateFields.OriginationLargeTransactionDiscountFee.name]: ZERO,
	[AchFeeTemplateFields.StandardReturnFee.name]: ZERO,
	[AchFeeTemplateFields.NoticeOfChangeReturnFee.name]: ZERO,
	[AchFeeTemplateFields.ChargebackReturnFee.name]: ZERO,
	[AchFeeTemplateFields.AccountVerificationFee.name]: ZERO,
	[AchFeeTemplateFields.AccountVerificationPlusFee.name]: ZERO,
};
